<h3 class="modal-title">Trade URL</h3>
<p class="modal-description">
  This is the URL that will be used to trade with other users.
</p>
<div class="divider horizontal w-full"></div>
<app-user-trade-url [onMountFocusTradeURL]="onMountFocusTradeURL()"
 />
